import { Box } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props) => (
	<Box {...p} {...p.customProps}>
		{p.children}
	</Box>
))
